import {
    Body,
    Box,
    Vec3
} from "cannon-es"
import { AnimationMixer, Object3D } from "three"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"

import { gsap } from "gsap"

import { randomNum } from "../components/alpha"
import { defPath, fetchPath } from '../config/defPath'
import { PopsController } from "./popsController"
// import { PopsController } from "./popsController"


// ------------------------------------------------------------

export class Gift {

    #_loader = new GLTFLoader()

    #_gltf
    #_base
    #_baseMixer
    #_baseAction

    #_positions = [
        {x: 55, y: 0, z: 20},
        {x: -55, y: 0, z: -20},
    ]

    #_active = {}


    constructor(params) {
        // this.#_params = params

        const name = 'base'
        const loadControl = window.loadControl
        
        this.#_base = new Promise( resolve => {
            this.#_loader
            .load( `${defPath}/assets/glb/${name}.glb`,
                (gltf) => {
                    const scene = gltf.scene

                    const sf = 1.2
                    scene.scale.set(sf,sf,sf)

                    this.#_baseMixer = new AnimationMixer(scene)
                    // this.#_baseMixer.timeScale = 0.25
                    const [clip] = gltf.animations
                    this.#_baseAction = this.#_baseMixer.clipAction(clip)

                    resolve(scene)
                },
                (xhr) => {
                    loadControl.elements['glb_' + name] = { loaded: xhr.loaded, total: xhr.total }
                    if (loadControl.allowLogSize && xhr.loaded === xhr.total) console.log(`GLB "${name}" - ${(xhr.total / 1024 / 1024).toFixed(2)}Mb`)
                },
                (error) => {
                    console.warn(`[A] ${name}: Error loading`)
                    // console.warn( error )
                }
            )
        })
    }

    async create() {

        const name = 'regalo'
        const loadControl = window.loadControl

        this.#_gltf = new Promise( resolve => {
            this.#_loader
            // .setDRACOLoader(this.#_draco)
            .load( `${defPath}/assets/glb/${name}.glb`,
                (gltf) => {
                    resolve(gltf.scene)
                },
                (xhr) => {
                    loadControl.elements['glb_' + name] = { loaded: xhr.loaded, total: xhr.total }
                    if (loadControl.allowLogSize && xhr.loaded === xhr.total) console.log(`GLB name "${name}" - ${(xhr.total / 1024 / 1024).toFixed(2)}Mb`)
                },
                (error) => {
                    console.warn(`[A] ${name}: Error loading`)
                    // console.warn( error )
                }
            )
        })

        await this.#_gltf 

        // Three
            const pos = this.#_positions[ randomNum(0, this.#_positions.length) ]

            const def = this.#_active.model = new Object3D()
            def.scale.set(5,5,5)
            def.position.copy(pos)

            def.add( await this.#_base )

            const gift = this.#_active.gift = await this.#_gltf
            gift.scale.set(0.85, 0.85, 0.85)
            gift.position.y = 0.25
            def.add( gift )

            window.scene.add( def )

        // Cannon
            const body = this.#_active.body = new Body({
                shape: new Box( new Vec3(4,4,4) ),
            })
            body.position.set(pos.x, 4.1, pos.z)


        let collided = false
            body.addEventListener('collide', (e) => {

                if (collided) return
                collided = true

                this.removeGift()

                window.soundController.play('gift', false, 1)

                new PopsController().open('regalo')

            })
            
            window.world.addBody(body)


            //

            this.#_baseAction.play()

    }

    removeGift() {

        const mesh = this.#_active.model
        const body = this.#_active.body

        // const mixer = this.#_baseMixer
        this.#_active.gift = undefined

        const t = gsap.timeline({
            defaults: {
                duration: 0.75,
                ease: 'power1.out'
            },
            onStart() {
                setTimeout(() => {
                    window.world.removeBody( body )
                }, 1)
            },
            onComplete() {
                window.scene.remove( mesh )
                // mixer = undefined
                t.kill()
            }
        })
        t.to(mesh.scale, {
            x: 0.01, y: 0.01, z: 0.01,
            ease: 'back.in(4)',
        }, 0)
        t.to(mesh.rotation, {
            y: Math.PI * 2.5,
        }, 0)

    }

    update(delta) {
        if(this.#_active.gift) {
            this.#_baseMixer.update(delta)
            this.#_active.gift.rotation.y += delta * 0.5
        }
    }


}